import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Reservations } from 'src/models/reserve.model';
import { CrudService } from 'src/services/crud.service';
import { DataService } from 'src/services/data.service';
import { ReserveService } from 'src/services/reserve.service';

@Component({
  selector: 'app-proceed-payment',
  templateUrl: './proceed-payment.component.html',
  styleUrls: ['./proceed-payment.component.css']
})
export class ProceedPaymentComponent implements OnInit {
  reservations = new Reservations();

  public data;
  currentDate:Date;
  constructor(public sanitizer: DomSanitizer, private dataService: DataService, private reserveService: ReserveService, private route: ActivatedRoute, private router: Router, private _crudService: CrudService) {
    this.currentDate =new Date();
    this.data = dataService.getOption();
    console.log('data', this.data);

    if (Object.keys(this.data).length === 0) {
      //this.router.navigateByUrl(`/reservation`);

      this.dataService.setOption('title', 'Mr.');
      this.dataService.setOption('name', 'Rakesh Yadav');
      this.dataService.setOption('email', 'amit.jha@teamcomputers.com');
      this.dataService.setOption('mobile', '8802904146');
      this.dataService.setOption('adult', '2');
      this.dataService.setOption('child', '2');
      this.dataService.setOption('amount', '1000');
      this.dataService.setOption('checkIn', new Date());
      this.dataService.setOption('checkOut', new Date((new Date()).setDate((new Date()).getDate() + 1)));
      this.dataService.setOption('request', 'this is test message to check payment gateway');
      this.dataService.setOption('days', '1');
      this.data = dataService.getOption();
    }

    // var RESERVATION_NAME = this.route.snapshot.queryParamMap.get('n');
    // var RESERVATION_EMAIL = this.route.snapshot.queryParamMap.get('e');
    // var RESERVATION_NO_OF_DAYS = this.route.snapshot.queryParamMap.get('d');
    // var RESERVATION_NO_OF_MEMBER = this.route.snapshot.queryParamMap.get('m');
    // var RESERVATION_NO_OF_CHILD = this.route.snapshot.queryParamMap.get('c');
    // var RESERVATION_ADVANCE_AMT = this.route.snapshot.queryParamMap.get('amt');
    // var RESERVATION_MOBILE_NO = this.route.snapshot.queryParamMap.get('mn');
    // var RESERVATION_CHECK_IN_DATE = this.route.snapshot.queryParamMap.get('cin');
    // var RESERVATION_CHECK_OUT_DATE = this.route.snapshot.queryParamMap.get('con');
    // this.reservations.RESERVATION_NAME = atob(RESERVATION_NAME);
    // this.reservations.RESERVATION_EMAIL = atob(RESERVATION_EMAIL);
    // this.reservations.RESERVATION_NO_OF_DAYS = atob(RESERVATION_NO_OF_DAYS);
    // this.reservations.RESERVATION_NO_OF_MEMBER = atob(RESERVATION_NO_OF_MEMBER);
    // this.reservations.RESERVATION_NO_OF_CHILD = atob(RESERVATION_NO_OF_CHILD);
    // this.reservations.RESERVATION_ADVANCE_AMT = atob(RESERVATION_ADVANCE_AMT);
    // this.reservations.RESERVATION_MOBILE_NO = atob(RESERVATION_MOBILE_NO);
    // this.reservations.RESERVATION_CHECK_IN_DATE = RESERVATION_CHECK_IN_DATE;
    // this.reservations.RESERVATION_CHECK_OUT_DATE = RESERVATION_CHECK_OUT_DATE;
  }

  ngOnInit() {
console.log(this.iframeSrc);
  }

  save() {
    this._crudService.post(``, this.reservations).subscribe((data: any) => {
      console.log(data);
    },
      (error) => {
        console.error(error.error.message);
      }
    )
  }

  iframeSrc: any;
  ProceedToPayment() {
    if (Object.keys(this.data).length === 0) {
      alert('Data is not available to proceed for Payment');
      return;
    }

    const formData = new FormData();
    formData.append("merchant_id", "283929");
    formData.append("order_id", Date.now().toString());
    formData.append("currency", "INR");
    formData.append("amount", this.data.amount);
    formData.append("redirect_url", this._crudService.PaymentResponseUrl);
    formData.append("cancel_url", this._crudService.PaymentResponseUrl);
    formData.append("integration_type", "iframe_normal");
    formData.append("language", "EN");
    formData.append("billing_name", this.data.name);
    formData.append("billing_address", "Tatva Hills");
    formData.append("billing_city", "Almora");
    formData.append("billing_state", "Uttarakhand");
    formData.append("billing_zip", "263680");
    formData.append("billing_country", "India");
    formData.append("billing_tel", this.data.mobile);
    formData.append("billing_email", this.data.email);
    formData.append("delivery_name", this.data.name);
    formData.append("Delivery_address", "Tatva Hills");
    formData.append("Delivery_city", "Almora");
    formData.append("delivery_state", "Uttarakhand");
    formData.append("delivery_zip", "263680");
    formData.append("delivery_country", "India");
    formData.append("delivery_tel", this.data.mobile);
    formData.append("merchant_param1", this.data.adult);
    formData.append("merchant_param2", this.data.child);
    formData.append("merchant_param3", new Date(this.data.checkIn).toDateString());
    formData.append("merchant_param4", new Date(this.data.checkOut).toDateString());
    formData.append("merchant_param5", this.data.request);
    // formData.append("promo_code", 'NA');
    // formData.append("entry_date", (new Date()).toDateString());
    //return;
    this.reserveService.ProceedToPayment(formData).subscribe(
      result => {
        console.log("Payment URL", result);
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(result);

      },
      error => {
        console.log(error);
      }
    );
  }
}
